module.exports = __webpack_public_path__ + "static/pic10-809d43037105a0ec76e6d1a8edb01b54.jpg";